import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/admin',
  timeout: 30000
})

let handling401 = false

function handleUnauthorized() {
  if (handling401) return
  handling401 = true
  // 先清 token，避免并发接口反复 401
  store.dispatch('user/resetToken').finally(() => {
    MessageBox.confirm('登录已过期，请重新登录', '提示', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning',
      showClose: false,
      closeOnClickModal: false
    }).then(() => {
      router.push('/login')
    }).catch(() => {
      router.push('/login')
    }).finally(() => {
      handling401 = false
    })
  })
}

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 1) {
      if (res.code === 401) {
        handleUnauthorized()
        // 不 reject：避免未捕获 Promise 触发 webpack 红屏
        return new Promise(() => {})
      }
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    Message.error((error && error.message) || '网络错误')
    return Promise.reject(error)
  }
)

export default service

export function toFormData(data, prefix = '') {
  const form = new FormData()
  appendFormData(form, data, prefix)
  return form
}

function appendFormData(form, data, prefix = '') {
  Object.keys(data).forEach(key => {
    const val = data[key]
    if (val === undefined || val === null) return
    const fullKey = prefix ? `${prefix}[${key}]` : key
    if (typeof val === 'object' && !Array.isArray(val) && !(val instanceof File) && !(val instanceof Blob)) {
      appendFormData(form, val, fullKey)
    } else if (Array.isArray(val)) {
      val.forEach((item, index) => {
        form.append(`${fullKey}[${index}]`, item)
      })
    } else {
      form.append(fullKey, val)
    }
  })
}
